/*=============================================== Image ===============================================*/
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*==================== Imports ====================*/
import React, { Suspense } from "react";
import styled from "styled-components";
import Variables from "../Variables";
import { P } from "../Font";
import Fallback from "../Fallback";
var Img = React.lazy(function () { return import("./Img"); });
/*==================== Component ====================*/
var Image = function (_a) {
    var src = _a.src, alt = _a.alt, width = _a.width, height = _a.height, fit = _a.fit, caption = _a.caption, props = __rest(_a, ["src", "alt", "width", "height", "fit", "caption"]);
    return (React.createElement(Suspense, { fallback: React.createElement(Fallback, { "$width": width, "$height": height }) }, caption ? (React.createElement(Container, __assign({ "$width": width, "$height": height }, props),
        React.createElement(Img, { src: src, alt: alt, "$width": width, "$height": height, "$fit": fit }),
        React.createElement(Caption, null, caption))) : (React.createElement(Img, __assign({ src: src, alt: alt, "$width": width, "$height": height, "$fit": fit }, props)))));
};
export default Image;
/*==================== Styles ====================*/
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n"], ["\n    position: relative;\n"])));
var Caption = styled(P)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: absolute;\n    z-index: 1;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    background-color: ", ";\n    padding: ", ";\n    color: ", ";\n"], ["\n    position: absolute;\n    z-index: 1;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    background-color: ", ";\n    padding: ", ";\n    color: ", ";\n"])), Variables.Overlays.Plain.Black80, Variables.Spacers.M, Variables.Colors.White);
var templateObject_1, templateObject_2;
